import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Mobile = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.538 5.158H7.385m10.153 13.684H7.385M18 19.895V4.105C18 2.943 17.173 2 16.154 2H7.846C6.826 2 6 2.943 6 4.105v15.79C6 21.057 6.827 22 7.846 22h8.308c1.02 0 1.846-.943 1.846-2.105"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Mobile) as SvgIcon;
export { ForwardRef as ReactComponent };
